if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }


      onSubmitHandler(evt) {
  evt.preventDefault();

  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const formData = new FormData(this.form);
  const mainVariantId = formData.get('id');

  const addonItems = Array.from(document.querySelectorAll('.addon-checkbox:checked')).map(checkbox => {
    const wrapper = checkbox.closest('.addon-item');
    const variantSelect = wrapper?.querySelector('.addon-variant-select');
    const quantityInput = wrapper?.querySelector('.addon-quantity');

    let variantId;

    if (variantSelect) {
      variantId = variantSelect.value || variantSelect.dataset.defaultVariantId;
    } else {
      variantId = wrapper?.dataset.variantId;
    }

    return {
      id: variantId,
      quantity: parseInt(quantityInput?.value || '1', 10)
    };
  }).filter(item => item.id);

  const submitMainAndAddons = async () => {
    try {
      // Add main product
      // await fetch('/cart/add.js', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ id: mainVariantId, quantity: 1 })
      // });

      // Add accessories
      for (const item of addonItems) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.id, quantity: item.quantity })
        });
      }

      // // Fetch updated cart and update UI
      // const res = await fetch('/cart.js');
      // const cart = await res.json();
      // const item_count = cart.item_count;

      // const cartnotification = document.querySelector('.cart_notification-btn');
      // if (cartnotification) cartnotification.textContent = `View cart (${item_count})`;

      // const cartBubble = document.querySelector('.cart-count-bubble');
      // if (cartBubble) {
      //   cartBubble.textContent = item_count;
      //   cartBubble.style.display = item_count > 0 ? 'inline-block' : 'none';
      // }

      // Native section update
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const shopifyResponse = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());

      if (shopifyResponse.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: mainVariantId,
          errors: shopifyResponse.errors || shopifyResponse.description,
          message: shopifyResponse.message,
        });
        this.handleErrorMessage(shopifyResponse.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (soldOutMessage) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
        }

        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error) {
         // Zoho SalesIQ - Add to Cart tracking
if (window.$zoho && $zoho.salesiq && $zoho.salesiq.visitor) {
  $zoho.salesiq.visitor.customaction("Add-to-Cart");
}

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: mainVariantId,
          cartData: shopifyResponse,
        });
        this.error = false;

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              this.cart.renderContents(shopifyResponse);
            });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(shopifyResponse);
        }
      }
    } catch (err) {
      console.error('Cart add failed:', err);
    } finally {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
      if (!this.error) {
        this.submitButton.removeAttribute('aria-disabled');
      }
      this.querySelector('.loading__spinner').classList.add('hidden');
    }
  };

  submitMainAndAddons();
}
      





      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
